export class PaginationParameters {
    pageIndex: number = 0;
    pageSize: number = 0;
    isAscending: boolean;
    totalItemCount: number = 0;
    orderByColumn:string;
}